// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"SmallLogoButton_logoContainer__3Yvpf","logo":"SmallLogoButton_logo__3K6ev"};